import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import { FormEvent, useState } from 'react';

type ChangePasswordFormProps = {
  onSubmit: (password: string) => void;
  isLoading: boolean;
};

export default function ChangePasswordForm({ onSubmit, isLoading }: ChangePasswordFormProps) {
  const [password, setPassword] = useState('');

  // not using formik because it is hard to integrate with this kind of validation
  const passwordConditions = {
    minLength: password.length >= 8,
    hasUppercase: /[A-Z]/.test(password),
    hasDigit: /[0-9]/.test(password),
    hasSymbol: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  };
  const isValid = Object.values(passwordConditions).every((condition) => condition);

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    if (isValid) {
      onSubmit(password);
    }
  }

  return (
    <form onSubmit={handleSubmit} style={{ margin: 0, width: '100%', padding: '5%' }}>
      <div style={{ textAlign: 'left' }}>
        <Typography level="body-md">Set a new password. Make sure it contains:</Typography>

        <ul>
          <ConditionCheckText isConditionValid={passwordConditions.minLength} conditionText={'8 or more characters'} />
          <ConditionCheckText isConditionValid={passwordConditions.hasUppercase} conditionText={'1 capital letter'} />
          <ConditionCheckText isConditionValid={passwordConditions.hasDigit} conditionText={'1 digit'} />
          <ConditionCheckText isConditionValid={passwordConditions.hasSymbol} conditionText={'1 symbol'} />
        </ul>
      </div>
      <Box display="flex" flexDirection="column" gap={3} alignItems="center" paddingTop={1}>
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          onChange={(event) => setPassword(event.target.value)}
          value={password}
          style={{
            display: 'block',
            width: '100%',
            border: 'none',
            borderBottom: '1px solid #9e9e9e',
            outline: 'none'
          }}
        />
        <Button type="submit" size="md" loading={isLoading} disabled={!isValid} sx={{ alignSelf: 'end', marginTop: 1 }}>
          Submit
        </Button>
        {/* api error is displayed as modal */}
      </Box>
    </form>
  );
}

type ConditionCheckProps = {
  isConditionValid: boolean;
  conditionText: string;
};

function ConditionCheckText({ isConditionValid, conditionText }: ConditionCheckProps) {
  const color = isConditionValid ? 'green' : 'black';
  const text = isConditionValid ? `✓ ${conditionText}` : conditionText;

  return (
    <ul>
      <li>
        <Typography level="body-md" sx={{ color }}>
          {text}
        </Typography>
      </li>
    </ul>
  );
}
